import { defineMessages } from 'react-intl'

export default defineMessages({
  iconUrl: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.IconURL',
    defaultMessage: 'App Icon URL & Preview'
  },
  iconUrlPlaceholder: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.IconURL.Placeholder',
    defaultMessage: 'https://www.exampleurl.com/appLogo.png'
  },
  invalidImage: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.FormError.invalidImage',
    defaultMessage: 'Please enter a valid Image URL. Valid image types are gif, jpg, jpeg, and png.'
  },
  invalidUrl: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.FormError.InvalidURL',
    defaultMessage: 'Please enter a valid URL.'
  },
  name: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.Name',
    defaultMessage: 'App Name'
  },
  namePlaceholder: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.Name.Placeholder',
    defaultMessage: 'App Name'
  },
  requiredError: {
    id: 'FormError.Required',
    defaultMessage: 'Please enter a value.'
  }
})
